import React from 'react';
import { InnerHtml } from '@geberit/gdds';

import styles from './chart-teaser.module.scss';

interface KeyFigureProps {
  description: string;
  title: string;
  value: string;
}

function KeyFigure({ description, title, value }: Readonly<KeyFigureProps>) {
  return (
    <div className={styles.keyFigure}>
      {title && <InnerHtml as="span" content={title} className={styles.figureTitle} />}
      {value && <InnerHtml as="span" content={value} className={styles.figureValue} />}
      {description && <InnerHtml as="p" content={description} className={styles.description} />}
    </div>
  );
}

export default KeyFigure;
